<template>
  <div class="container-requests">
    <div id="widget"></div>
  </div>
</template>
<script>
export default {
  name: "aftersale",
	props: {
		assetId: { default: null },
		contractId: {default: null},
	},
  mounted() {
    let self = this;
    setTimeout(function(){
      document.getElementById('widget').innerHTML = `<mobysuite-aftersale-client customer="${self.customer}" customer-id="${self.customerId}" contract-id="${self.contractId}"><mobysuite-aftersale-client>`;
      let script = document.createElement("script");
      script.src = "https://cdn.mobysuite.com/aftersale-widget/js/app.js";
      document.getElementById('widget').appendChild(script);
    }, 500);
  },
  computed: {
    customer() {
      return this.$store.getters.getCustomer;
    },
    customerId() {
      return this.$store.getters.getCustomerData ? this.$store.getters.getCustomerData.customer_id : 0;
    },
  },
};
</script>
<style></style>
